<template>
    <vue-custom-scrollbar class="workspace-module-container" @ps-y-reach-end="scrollReachEnd">
        <div id="projects-container">
            <div v-for="(project) in projectList" class="project-preview"
                 v-on:click="selectProject(project.guid)" @dblclick="openProject(project.guid)"
                 v-bind:class="{'active-project': projectSelected === project.guid}">
<!--                <img class="project-preview-image" :src="titleImageProject(project.data_json)"/>-->
                <TitlePhotoForProject :dataProject="project.data_json"/>
                <div class="project-preview-text-container collapsable-ellipsis" v-if="project.data_json">
                    <span class="project-preview-text">{{project.data_json.name}}</span>
                </div>
            </div>
        </div>
        <div v-if="waitingResponseToProjectsRequest" class="ap-loader-grid">
            <SpinnerTwo/>
            <div class="ap-loader-text">
                Идет загрузка проектов ...
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import {urlForFileStorage, urlForStaticVue} from "../common";
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import SpinnerTwo from "../SpinnerTwo";
    import TitlePhotoForProject from "./TitlePhotoForProject";

    export default {
        name: "WorkspaceProjects",
        components: {
            TitlePhotoForProject,
            vueCustomScrollbar,
            SpinnerTwo
        },
        mixins: [urlForFileStorage, urlForStaticVue],
        data() {
            return {
                photo: null
            }
        },
        computed: {
            projectList() {
                return this.$store.getters["UI/loadedProjectList/UPLOADED_PROJECTS"];
            },
            projectSelected() {
                return this.$store.state.route.params.projectUUID;
            },
            waitingResponseToProjectsRequest() {
                return this.$store.state.UI.loadedProjectList.waitingResponseToProjectsRequest;
            }
        },
        methods: {
            selectProject(projectGUID) {
                this.$router.replace({
                    name: "selectProject",
                    params: {projectUUID: projectGUID}
                }).catch((err) => {
                });
            },
            openProject(projectGUID) {
                this.$router.push({
                    name: "loadPhoto",
                    params: {projectUUID: projectGUID}
                }).catch((err) => {
                });
            },
            // titleImageProject(photoList) {
            //     for (let idPhoto in photoList) {
            //         return this.urlForFileStorage(photoList[idPhoto].src);
            //     }
            //     return this.urlForStatic('img/No_Picture.jpg');
            // },
            scrollReachEnd() {
                this.$store.dispatch('UI/loadedProjectList/GET_PROJECTS');
            },
        },
        mounted() {
            this.$store.dispatch('UI/loadedProjectList/GET_PROJECTS');
        },
        destroyed() {
            this.$store.dispatch('projectList/DELETE_ALL_PROJECTS_EXCEPT_ACTIVE');
            this.$store.commit('UI/loadedProjectList/CLEAR_UPLOADED_PROJECTS');
        }
    }
</script>

<style scoped>
    .workspace-module-container {
        background-color: #f2f2f2;
        user-select: none;
    }

    #projects-container {
        padding: 50px 0 0 40px;
    }
</style>
